<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Impuestos y servicios</b-card-header>
      <b-card-body>
        <form-wizard color="#ff5955" backButtonText="Atras" ref="wizard" title subtitle :hide-buttons="true">
          <template slot="step" scope="props">
            <wizard-step :tab="props.tab" :transition="props.transition" :index="props.index"></wizard-step>
          </template>
          <tab-content title="Seleccionar rubro" icon="fa fa-fw fa-clipboard-list">
            <div
              class="row"
              v-for="item in rubros"
              @click="rubroClicked(item)"
              v-bind:key="item.EntityID"
              :value="item.EntityID"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px;">
                  <div>
                    <img :src="item.Icon" style="width30px;height:30px;" />
                    <span style="vertical-align: middle; margin-left: 10px;">{{item.Name}}</span>
                  </div>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">></div>
            </div>
          </tab-content>
          <tab-content title="Seleccionar empresa" icon="fa fa-fw fa-store">
            <div class="row">
              <div
                class="col-md-12 text-center"
                style="color: #ff5955; font-size: 30px"
              >{{rubro.Name}}</div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Buscar..."
                  addon-left-icon="fa fa-fw fa-search"
                  @keyup="buscarArticulo()"
                  v-model="textArticulo"
                ></base-input>
              </div>
            </div>
            <div
              class="row"
              v-for="item in articulos"
              @click="articuloClicked(item)"
              v-bind:key="item.EntityID"
              :value="item.EntityID"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px;">
                  <div>
                    <!-- <i
                      style="font-size: 30px; color: #ff5955; vertical-align: middle"
                      class="fa fa-fw fa-store"
                    ></i>-->
                    <img :src="rubro.Icon" style="width30px;height:30px;" />
                    <span style="vertical-align: middle; margin-left: 10px;">{{item.ArticleName}}</span>
                  </div>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">></div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
              </div>
            </div>
          </tab-content>

          <tab-content title="Ingreso de factura" icon="fa fa-fw fa-file-invoice-dollar">
            <div class="row">
              <div
                class="col-md-12 text-center"
                style="color: #ff5955; font-size: 30px"
              >{{articulo.ArticleName}}</div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  class="input-group-alternative mb-3"
                  placeholder="Código de barras"
                  addon-left-icon="fa fa-fw fa-barcode"
                  v-model="codigobarras"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center" v-if="ingresosmanuales.length>0">O bien ingrese</div>
              <div
                class="col-md-12"
                v-for="item in ingresosmanuales"
                v-bind:key="item.Code"
                :value="item.Code"
                style
              >
                <label>{{item.Name}}</label>
                <base-input
                  class="input-group-alternative mb-3"
                  v-if="item.DataTypeEntityID == tiposingresos.Numerico"
                  v-model="item.Value"
                  type="number"
                ></base-input>

                <vue-numeric
                  currency="$"
                  v-bind:precision="2"
                  decimal-separator="."
                  thousand-separator=" "
                  v-model="item.Value"
                  class="form-control"
                  v-if="item.DataTypeEntityID == tiposingresos.Importe"
                ></vue-numeric>
              </div>
            </div>

            <div class="row">
              <div class="col-3">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
              </div>
              <div class="col-6 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="validarFactura"
                  style="margin: auto; margin-top: 10px"
                >
                  <i class="fa fa-file-invoice-dollar fa-fw"></i>Validar factura
                </base-button>
              </div>
            </div>
          </tab-content>

          <tab-content title="Selección de factura" icon="fa fa-fw fa-hand-pointer">
            <div class="row">
              <div
                class="col-md-12 text-center"
                style="color: #ff5955; font-size: 30px"
              >{{articulo.ArticleName}}</div>
            </div>
            <div
              class="row"
              v-for="item in validacionfacturas.Bills"
              v-bind:key="item.CodeBar"
              :value="item.CodeBar"
              style="padding: 5px; border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
            >
              <div class="col-10">
                <div style="margin-left: 10px; display: flex">
                  <div style="margin-right: 20px;">{{item.Text}}. Importe a pagar</div>
                  <vue-numeric
                    currency="$"
                    v-bind:precision="2"
                    decimal-separator="."
                    thousand-separator=" "
                    v-model="item.Amount"
                    class="form-control"
                    style="max-width: 200px"
                    v-if="item.PartialPay || item.Amount == 0"
                  ></vue-numeric>
                  <span v-else>{{item.FormatedAmount}}</span>
                </div>
              </div>
              <div class="col-2 text-right" style="padding-right: 25px">
                <base-button type="danger" size="sm" @click="onPagarFactura(item)">
                  <i class="fa fa-file-invoice-dollar fa-fw"></i>Pagar
                </base-button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <base-button type="danger" size="lg" @click="atras" style="margin-top: 10px">Atras</base-button>
              </div>
            </div>
          </tab-content>

          <tab-content title="Resultado" icon="fa fa-fw fa-flag">
            <div class="row">
              <div class="col-md-12">
                <base-alert :type="resultado.Tipo">
                  <span class="alert-inner--icon">
                    <i :class="resultado.Icono"></i>
                  </span>
                  <span class="alert-inner--text" v-html="resultado.Texto"></span>
                </base-alert>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-center">
                <base-button
                  type="success"
                  size="lg"
                  @click="nuevoPago"
                  style="margin: auto; margin-top: 10px"
                >
                  <i class="fa fa-plus fa-fw"></i>Iniciar nuevo pago
                </base-button>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </b-card-body>
    </b-card>
    <pin-validation ref="pin-validation"
      :showModal.sync="showModalPinValidation"
      v-on:validPin="onValidPin"
      v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation>
  </div>
</template>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import PinValidation from '@/views/Pin/PinValidation';

export default {
  components: {
    FormWizard,
    TabContent,
    WizardStep,
    "pin-validation": PinValidation
  },
  data() {
    return {
      rubro: { Name: "", EntityID: 0 },
      rubros: [],

      articulos: [],
      textArticulo: "",
      articulo: {
        PartialPay: false,
        ArticleName: "",
        ArticleAbbreviation: "",
        ArticleCategoryName: ""
      },

      ingresosmanuales: [],
      codigobarras: "",

      validacionfacturas: { Bills: [] },

      estados: { Aprobado: 3, Rechazado: 4, Consulta: 5 },
      tiposingresos: { Numerico: 1, Importe: 2 },

      resultado: { Icono: "", Texto: "", Tipo: "" },

      usePaymentPin: false,
      showModalPinValidation: false,
      itemPagarFactura: null
    };
  },
  methods: {
    rubroClicked(item) {
      this.$refs.wizard.nextTab();
      this.rubro = item;
    },
    articuloClicked(item) {
      let context = this;
      context.articulo = item;

      axiosHelpers.axiosGet(
        "BillPayment/GetManualInputsByArticle",
        { ArticleID: context.articulo.EntityID },
        context,
        function(data) {
          context.ingresosmanuales = data.ResponseVM;
          context.$refs.wizard.nextTab();
        }
      );
    },
    buscarArticulo() {
      let context = this;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (context.textArticulo != null && context.textArticulo.length > 2) {
          axiosHelpers.axiosGet(
            "BillPayment/GetForSearchControl",
            { Text: context.textArticulo, CategoryID: context.rubro.EntityID },
            context,
            function(data) {
              context.articulos = data.ResponseVM;
            }
          );
        }
      }, 800);
    },
    validarFactura() {
      let ingresosValidos = false;
      if (this.ingresosmanuales.length > 0) {
        for (var i = 0; i < this.ingresosmanuales.length; i++) {
          if (
            this.ingresosmanuales[i].Value != null &&
            this.ingresosmanuales[i].Value != ""
          ) {
            ingresosValidos = true;
            break;
          }
        }
      }

      if (this.codigobarras == "" && ingresosValidos == false) {
        notificationHelpers.showError(
          "Advertencia!",
          "Debe completar el código de barras o los ingresos manuales",
          this
        );
        return;
      }

      let context = this;
      axiosHelpers.axiosPost(
        "BillPayment/ValidateBill",
        {
          ArticleCobroExpressID: context.articulo.EntityID,
          BarCode: context.codigobarras,
          ManualInputs: context.ingresosmanuales
        },
        context,
        function(data) {
          if (
            data.ResponseVM.Bills != null &&
            data.ResponseVM.Bills.length > 0
          ) {
            context.validacionfacturas = data.ResponseVM;
            context.$refs.wizard.nextTab();
          } else {
            // -- Se deja comentado para hacer pruebas

            // var sim = {
            //   ArticleName: "Esta es",
            //   CategoryName: "para vos",
            //   PartialPay: false,
            //   Bills: []
            // };
            // sim.Bills.push({
            //   Amount: 1050,
            //   CodeBar: "12321321321",
            //   Text: "Facturita",
            //   Hash: "sdfdsf234",
            //   FormatedAmount: "$1050,00",
            //   PartialPay: false
            // });
            // sim.Bills.push({
            //   Amount: 676.12,
            //   CodeBar: "9897978",
            //   Text: "Apaaaaa",
            //   Hash: "xx3333",
            //   FormatedAmount: "$676,12",
            //   PartialPay: true
            // });
            // context.$refs.wizard.nextTab();

            // context.validacionfacturas = sim;

            if (data.Alerts == null || data.Alerts.length == 0) {
              notificationHelpers.showWarning(
                "Advertencia!",
                "No se encontraron facturas para cobrar",
                context
              );
            }
          }
        }
      );
    },
    onPagarFactura(item) {
      let context = this;

      context.itemPagarFactura = item;
      context.pinValidate();
    },
    pagarFactura() {
      let context = this;
      let item = context.itemPagarFactura;
      
      axiosHelpers.axiosPost(
        "BillPayment/InsertAndWaitResult",
        {
          BarCode: item.CodeBar,
          Hash: item.Hash,
          ArticleCobroExpressID: context.articulo.EntityID,
          Amount: item.Amount
        },
        context,
        function(data) {
          if (data.Alerts.length == 0) {
            if (
              data.ResponseVM.TransactionStateID == context.estados.Aprobado
            ) {
              let msg =
                "El pago se realizó satisfactoriamente" +
                "<br/>" +
                " Número de operación: " +
                data.ResponseVM.QueueID +
                "<br/>" +
                " Número de comprobante: " +
                data.ResponseVM.FormatedReceiptID +
                "<br/>" +
                " Número de transacción: " +
                data.ResponseVM.TransactionNumber +
                "<br/>";

              context.resultado = {
                Texto: msg,
                Tipo: "success",
                Icono: "fa fa-fw fa-thumbs-up"
              };
              context.$refs.wizard.nextTab();
            } else if (
              data.ResponseVM.TransactionStateID == context.estados.Rechazado ||
              data.ResponseVM.TransactionStateID == context.estados.Consulta
            ) {
              context.resultado = {
                Texto: data.ResponseVM.ErrorMsg,
                Tipo: "danger",
                Icono: "fa fa-fw fa-thumbs-down"
              };
              context.$refs.wizard.nextTab();
            } else {
              context.resultado = {
                Texto:
                  "La operación esta demorando mas de lo normal, te avisaremos cuando este el resultado final de la operación",
                Tipo: "warning",
                Icono: "fa fa-fw fa-clock"
              };
              context.$refs.wizard.nextTab();
            }
          } else {
            context.resultado = {
              Texto: data.Alerts[0].Message,
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down"
            };
            context.$refs.wizard.nextTab();
          }
        }
      );
    },
    atras() {
      this.$refs.wizard.prevTab();
    },
    nuevoPago() {
      this.$refs.wizard.reset();
    },
    onValidPin(val) {
      let context = this;

      if(val) {
        context.pagarFactura();
      }
    },
    onLoadUsePaymentPin(val) {
      let context = this;

      context.usePaymentPin = val;
    },
    pinValidate() {
      let context = this;

      if(context.usePaymentPin) {
        context.showModalPinValidation = true;
      } else {
        context.pagarFactura();
      }
    }
  },
  beforeMount: function() {
    // let context = this;

    // axiosHelpers.axiosGet(
    //   "BillPayment/GetCobroExpressCategories",
    //   {},
    //   this,
    //   function(data) {
    //     context.rubros = data.ResponseVM;
    //   }
    // );
  }
};
</script>